var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.171 12.201v1.448l5.84-3.307L8.171 6v1.757C6.484 7.98 2.85 9.183 1.816 12.2.523 15.974.782 18.3 2.487 20.987c1.705 2.687 5.58 4.29 10.18 3.204 3.68-.868 6.08-6.115 6.821-8.63-.993.58-2.018 1.266-3.03 1.942-2.412 1.61-4.753 3.174-6.427 3.174a4.664 4.664 0 0 1-4.65-3.98c-.258-1.963 1.086-4.495 2.791-4.495zm15.659 8.147V18.9l-5.84 3.308 5.839 4.34v-1.757c1.687-.223 5.321-1.425 6.355-4.443 1.292-3.772 1.033-6.097-.672-8.785-1.705-2.687-5.58-4.289-10.18-3.203-3.68.867-6.08 6.114-6.821 8.628.993-.58 2.018-1.265 3.03-1.942 2.412-1.61 4.753-3.173 6.427-3.173a4.664 4.664 0 0 1 4.65 3.978c.258 1.965-1.086 4.497-2.791 4.497z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/SWAP.4bf515cd2226b8733f793b20f6bf4359.svg";
export { ForwardRef as ReactComponent };